export default __webpack_public_path__ + "static/insight-dark-a57c9cc12c98cb52be4dbc49d606e6f3.png";